import { defineStore } from 'pinia'

export const useNewsSettingsStore = defineStore('newsSettingsStore', {
  state: () => ({
    hideSmallBattles: false,
    minimumShipsPerSide: 5
  }),
  getters: {},
  actions: {
    setHideSmallBattles(value: boolean) {
      this.hideSmallBattles = value
    },
    setMinimumShipsPerSide(value: number) {
      this.minimumShipsPerSide = value
    }
  },
  persist: {
    key: 'newsSettingsStore',
    storage: localStorage,
    serializer: {
      serialize: (state) => {
        // Deep clone using JSON
        const cloned = JSON.parse(JSON.stringify(state))
        return JSON.stringify(cloned)
      },
      deserialize: (value) => JSON.parse(value)
    }
  }
}) 